import {app} from '../app';


export class LogoutController {

    static $inject = ['authService'];

    constructor(authService: any) {
        // Log out locally
        authService.logoutLocally();
    }

}

app.controller('LogoutController', LogoutController);
